<div>
  <po-button p-label="Exportar relatório" p-kind="primary" (p-click)="modalExport.open()" />
  <po-modal #modalExport p-size="sm" p-title="Exportar relatório">
    <po-dynamic-form
      #dynamicFormExport
      [p-fields]="exportFormFields"
      [p-value]="exportFormValues"
      [p-validate-fields]="validateFields"
    />
    <po-modal-footer>
      <po-button p-label="Cancelar" (p-click)="modalExport.close()" />
      <po-button p-label="Exportar relatório" p-kind="primary" (p-click)="handleExport()" />
    </po-modal-footer>
  </po-modal>
</div>